import {useFormikContext} from 'formik';
import {formatBirthdateToText, formatDateToText} from '../../../../../../helpers/modalBenhAn';
import CustomComponent from '../components/CustomComponent';
import {HO_SO_BENH_AN_FORM} from '../../../../../../constants/BenhAn';
import {useHoSoBenhAnContext} from '../context';
import {useDetailHoSoBenhAn, useMedicalRecordFormIO} from '../../../../../../modals/modal-benh-an/hooks/hoSoBenhAn';
import {OctGenerateForm} from '@oceantech/oceantech-ui';
import {useEffect} from 'react';
import {usePhanHeKhamBenhContext} from "../../../../../../contexts/PhanHeTiepDonContext";

const TrangBia = (props: any) => {
  const {setFieldValue, values} = useFormikContext<any>();
  const {hideAction} = useHoSoBenhAnContext();
  const {benhNhanInfo} = usePhanHeKhamBenhContext();

  const benhNhanDieuTri = benhNhanInfo?.thongTinKhamBenh || {}

  const {formJSON} = useMedicalRecordFormIO({
    medicalRecordCode: props.medicalRecordTypeCode,
    formCode: HO_SO_BENH_AN_FORM.TRANG_1,
  });
  const {data} = useDetailHoSoBenhAn({
    medicalRecordId: benhNhanDieuTri?.encounterIdExec,
    formName: HO_SO_BENH_AN_FORM.TRANG_1,
  });
  useEffect(() => {
    if (data) {
      setFieldValue('forms', data);
    }
  }, [data]);

  return (
    <OctGenerateForm
      listFieldAuto={formJSON}
      setFieldValue={setFieldValue}
      values={values}
      modelID="forms"
      readOnly={hideAction}
      customComponent={CustomComponent}
      fieldConditionalConfig={{
        formatDateToText,
        formatBirthdateToText,
      }}
    />
  );
};

export default TrangBia;
